// Read hook for the cross-transaction AI review summary (AI Assurance report).
//
// One server round-trip returns every transaction's newest completed review
// (quote-free). The AI Assurance page joins this against useCesRowsByRef to
// compute coverage + agreement. Gated server-side to report-lead roles, and
// `enabled` lets the caller defer the fetch until the page is shown.
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../lib/queryKeys';
import { adminApi, type AiReviewSummaryRow } from '../lib/adminApi';

export function useAiReviewLatestAll(enabled = true) {
  return useQuery<AiReviewSummaryRow[]>({
    queryKey: queryKeys.aiReviewLatestAll,
    queryFn: async () => (await adminApi.aiReviewLatestAll()).results,
    enabled,
  });
}
